import React from 'react';
import { XIcon, FilterIcon } from 'lucide-react';
import { categories } from '../../data/categories';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
interface ProductFiltersProps {
  selectedCategory: string;
  selectedBrand: string;
  priceRange: [number, number];
  onCategoryChange: (category: string) => void;
  onBrandChange: (brand: string) => void;
  onPriceRangeChange: (range: [number, number]) => void;
  onClearFilters: () => void;
  isMobile?: boolean;
  onClose?: () => void;
}
const brands = ['Apple', 'Samsung', 'Xiaomi', 'Anker', 'JBL', 'Logitech', 'Razer', 'Baseus', 'Amazfit', 'Keychron'];
export function ProductFilters({
  selectedCategory,
  selectedBrand,
  priceRange,
  onCategoryChange,
  onBrandChange,
  onPriceRangeChange,
  onClearFilters,
  isMobile = false,
  onClose
}: ProductFiltersProps) {
  const hasActiveFilters = selectedCategory || selectedBrand || priceRange[0] > 0 || priceRange[1] < 200000;
  const content = <div className="space-y-6" data-id="element-796" data-mp="1fnsszbxmgs4r">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-797" data-mp="1foatwlv8buj0">
        <div className="flex items-center gap-2" data-id="element-798" data-mp="1ap80jyom3cqv">
          <FilterIcon className="w-5 h-5 text-gray-600" data-id="element-799" data-mp="1aqj2dsyhyafc" />
          <h3 className="font-semibold text-gray-900" data-id="element-800" data-mp="1pdud5smutqee">Filters</h3>
        </div>
        {hasActiveFilters && <button onClick={onClearFilters} className="text-sm text-primary-600 hover:text-primary-700 font-medium" data-id="element-801" data-mp="1kmm2yudpa106">
            Clear all
          </button>}
      </div>

      {/* Categories */}
      <div data-id="element-802" data-mp="1tfphz73zulwx">
        <h4 className="font-medium text-gray-900 mb-3" data-id="element-803" data-mp="1te5yl7n1juqx">Categories</h4>
        <div className="space-y-2" data-id="element-804" data-mp="28c6nhhpi56bk">
          <label className="flex items-center gap-2 cursor-pointer" data-id="element-805" data-mp="28b5dzho4wrvy">
            <input type="radio" name="category" checked={!selectedCategory} onChange={() => onCategoryChange('')} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-806" data-mp="23cu4j81r4je9" />
            <span className="text-sm text-gray-700" data-id="element-807" data-mp="8zccb7qeiycw">All Categories</span>
          </label>
          {categories.map(category => <label key={category.id} className="flex items-center gap-2 cursor-pointer" data-id="element-808" data-mp="ynrm450mb826">
              <input type="radio" name="category" checked={selectedCategory === category.slug} onChange={() => onCategoryChange(category.slug)} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-809" data-mp="12otkykqmhi3m" />
              <span className="text-sm text-gray-700" data-id="element-810" data-mp="1cmzof6s2uwal">{category.name}</span>
              <span className="text-xs text-gray-400 ml-auto" data-id="element-811" data-mp="1ckwn3qlh5gqk">
                ({category.productCount})
              </span>
            </label>)}
        </div>
      </div>

      {/* Brands */}
      <div data-id="element-812" data-mp="1llur48vwxo95">
        <h4 className="font-medium text-gray-900 mb-3" data-id="element-813" data-mp="1qenwmyz7h0ma">Brands</h4>
        <div className="space-y-2 max-h-48 overflow-y-auto" data-id="element-814" data-mp="1qf7fchwojt1d">
          <label className="flex items-center gap-2 cursor-pointer" data-id="element-815" data-mp="1ve0ibgecc1na">
            <input type="radio" name="brand" checked={!selectedBrand} onChange={() => onBrandChange('')} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-816" data-mp="20ctxred6u2q3" />
            <span className="text-sm text-gray-700" data-id="element-817" data-mp="25cgdbughnv22">All Brands</span>
          </label>
          {brands.map(brand => <label key={brand} className="flex items-center gap-2 cursor-pointer" data-id="element-818" data-mp="3pvad90fwe3g7">
              <input type="radio" name="brand" checked={selectedBrand === brand} onChange={() => onBrandChange(brand)} className="w-4 h-4 text-primary-600 focus:ring-primary-500" data-id="element-819" data-mp="3ktb7xl0lkwgm" />
              <span className="text-sm text-gray-700" data-id="element-820" data-mp="3axro3wzb5o88">{brand}</span>
            </label>)}
        </div>
      </div>

      {/* Price Range */}
      <div data-id="element-821" data-mp="ch5k633w03d8">
        <h4 className="font-medium text-gray-900 mb-3" data-id="element-822" data-mp="cgx7ab7rky21">Price Range</h4>
        <div className="flex items-center gap-2" data-id="element-823" data-mp="7ghtjijklojj">
          <Input type="number" placeholder="Min" value={priceRange[0] || ''} onChange={e => onPriceRangeChange([Number(e.target.value) || 0, priceRange[1]])} className="text-sm" data-id="element-824" data-mp="2orgv5x5uooy" />
          <span className="text-gray-400" data-id="element-825" data-mp="v5kaeo6drdcz">-</span>
          <Input type="number" placeholder="Max" value={priceRange[1] === 200000 ? '' : priceRange[1]} onChange={e => onPriceRangeChange([priceRange[0], Number(e.target.value) || 200000])} className="text-sm" data-id="element-826" data-mp="v6c947v9xr7h" />
        </div>
        <div className="flex flex-wrap gap-2 mt-3" data-id="element-827" data-mp="avj81oyb9uvl">
          <button onClick={() => onPriceRangeChange([0, 5000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-828" data-mp="fw75oth1p9ys">
            Under PKR 5K
          </button>
          <button onClick={() => onPriceRangeChange([5000, 20000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-829" data-mp="5xzqaf2emzyw">
            PKR 5K - 20K
          </button>
          <button onClick={() => onPriceRangeChange([20000, 50000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-830" data-mp="jy267vr5jjbi">
            PKR 20K - 50K
          </button>
          <button onClick={() => onPriceRangeChange([50000, 200000])} className="px-3 py-1 text-xs rounded-full border border-gray-200 hover:border-primary-500 hover:text-primary-600 transition-colors" data-id="element-831" data-mp="1ckmtol4ibb9s">
            Above PKR 50K
          </button>
        </div>
      </div>

      {/* Mobile apply button */}
      {isMobile && onClose && <div className="pt-4 border-t border-gray-200" data-id="element-832" data-mp="3bt50d7uv9aj1">
          <Button variant="primary" fullWidth onClick={onClose} data-id="element-833" data-mp="3brtnmijg0sfs">
            Apply Filters
          </Button>
        </div>}
    </div>;
  if (isMobile) {
    return <div className="fixed inset-0 z-50 bg-white overflow-y-auto" data-id="element-834" data-mp="2j47fqy36n1n4">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between" data-id="element-835" data-mp="2j6jzngsi3m2t">
          <h2 className="font-semibold text-gray-900" data-id="element-836" data-mp="2s55plx0ay3dm">Filters</h2>
          <button onClick={onClose} className="p-2 text-gray-500 hover:text-gray-700" data-id="element-837" data-mp="2s6gr1q69yz1k">
            <XIcon className="w-5 h-5" data-id="element-838" data-mp="2o1z97wjh6vtf" />
          </button>
        </div>
        <div className="p-4" data-id="element-839" data-mp="7e55tguf33s8">{content}</div>
      </div>;
  }
  return <div className="bg-white rounded-xl border border-gray-100 shadow-card p-5" data-id="element-840" data-mp="7grb19tu577a">
      {content}
    </div>;
}